// src/pages/vendor/VendorSetPassword.jsx
import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../firebase";

export default function VendorSetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const validate = () => {
    if (!token) return "Lien invalide.";
    if (password.length < 8) return "Le mot de passe doit contenir au moins 8 caractères.";
    if (password !== confirmPassword) return "Les mots de passe ne correspondent pas.";
    return "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    const msg = validate();
    if (msg) {
      setError(msg);
      return;
    }

    try {
      setLoading(true);

      const fn = httpsCallable(functions, "finalizeVendorPasswordSetup");
      const res = await fn({
        token,
        password,
      });

      setSuccess(
        res?.data?.message ||
          "Mot de passe défini avec succès. Vous pouvez maintenant vous connecter."
      );
      setPassword("");
      setConfirmPassword("");
    } catch (err) {
      console.error(err);
      setError(err?.message || "Impossible de définir le mot de passe.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="vsp-page">
      <div className="vsp-card">
        <span className="vsp-kicker">Sécurité compte vendeur</span>
        <h1 className="vsp-title">Définir votre mot de passe</h1>
        <p className="vsp-muted">
          Choisissez un mot de passe sécurisé pour activer votre compte vendeur GoShop.
        </p>

        {error ? <div className="vsp-alert vsp-alert-error">{error}</div> : null}
        {success ? <div className="vsp-alert vsp-alert-success">{success}</div> : null}

        <form onSubmit={handleSubmit} className="vsp-form">
          <div className="vsp-field">
            <label>Nouveau mot de passe</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Au moins 8 caractères"
            />
          </div>

          <div className="vsp-field">
            <label>Confirmer le mot de passe</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Retapez le mot de passe"
            />
          </div>

          <button type="submit" className="vsp-btn" disabled={loading}>
            {loading ? "Validation..." : "Enregistrer mon mot de passe"}
          </button>
        </form>

        <div className="vsp-footer">
          <Link to="/login">Aller à la connexion</Link>
        </div>
      </div>

      <style>{`
        .vsp-page{
          min-height:100vh;
          display:flex;
          align-items:center;
          justify-content:center;
          padding:24px 16px;
          background:linear-gradient(180deg,#eef2ff 0%, #f8fafc 100%);
        }
        .vsp-card{
          width:100%;
          max-width:480px;
          background:#fff;
          border:1px solid #e5e7eb;
          border-radius:24px;
          padding:22px;
          box-shadow:0 22px 48px rgba(15,23,42,.08);
        }
        .vsp-kicker{
          display:inline-flex;padding:4px 10px;border-radius:999px;background:#dcfce7;
          color:#166534;font-size:11px;font-weight:900;margin-bottom:10px;
        }
        .vsp-title{margin:0 0 6px;font-size:26px;font-weight:900;color:#0f172a;}
        .vsp-muted{margin:0 0 16px;color:#64748b;font-size:14px;}
        .vsp-alert{
          border-radius:12px;padding:10px 12px;font-size:13px;font-weight:700;margin-bottom:12px;
        }
        .vsp-alert-error{background:#fef2f2;color:#b91c1c;border:1px solid #fecaca;}
        .vsp-alert-success{background:#ecfdf3;color:#166534;border:1px solid #bbf7d0;}
        .vsp-form{display:flex;flex-direction:column;gap:12px;}
        .vsp-field{display:flex;flex-direction:column;gap:6px;}
        .vsp-field label{font-size:13px;font-weight:800;color:#334155;}
        .vsp-field input{
          border:1px solid #d1d5db;border-radius:14px;padding:12px 14px;font-size:14px;outline:none;
        }
        .vsp-field input:focus{
          border-color:#2563eb;box-shadow:0 0 0 3px rgba(37,99,235,.08);
        }
        .vsp-btn{
          margin-top:6px;border:none;border-radius:999px;padding:12px 16px;
          background:#0f172a;color:#fff;font-size:14px;font-weight:900;cursor:pointer;
        }
        .vsp-footer{margin-top:14px;font-size:13px;}
      `}</style>
    </div>
  );
}